import React, { useState, useEffect, useRef } from 'react';
import './CategoryBackground.css';
import { WORKS, isVideo, mediaUrl } from './worksData';
import { getHighlights, getHiddenWorks, getDeletedWorks } from './store';

const INTERVAL_MS = 1100; // durée d'affichage de chaque travail

export default function CategoryBackground({ cat }) {
  // Visuels mis en avant depuis l'admin (démarrage du site + fond d'accueil).
  // Uniquement pour "tous" : le survol d'une catégorie garde son propre filtre.
  const [highlights, setHighlights] = useState([]);
  const [masques, setMasques] = useState([]);

  useEffect(() => {
    Promise.all([getHiddenWorks(), getDeletedWorks()]).then(([h, d]) =>
      setMasques([...(h || []), ...(d || [])])
    );
  }, []);

  useEffect(() => {
    if (cat !== 'tous') return;
    getHighlights().then((list) => setHighlights(list || []));
  }, [cat]);

  // Travaux retirés depuis l'admin : jamais affichés en fond
  const visibles = WORKS.filter((w) => !masques.includes(w.label));
  const pool = visibles.filter((w) => w.cat === cat);
  let source;
  if (cat === 'tous' && highlights.length > 0) {
    source = highlights.map((url) => ({ image: url }));
  } else {
    source = pool.length ? pool : visibles;
  }

  const [index, setIndex] = useState(0);
  const timer = useRef(null);
  const count = source.length;

  // Défilé automatique : un travail après l'autre
  useEffect(() => {
    setIndex(0);
    if (count === 0) return undefined;
    timer.current = setInterval(() => {
      setIndex((i) => (i + 1) % count);
    }, INTERVAL_MS);
    return () => clearInterval(timer.current);
  }, [cat, count]);

  return (
    <div className="cat-bg">
      {source.map((item, i) => {
        const src = mediaUrl(item.image);
        return (
          <div
            key={i}
            className={`cat-slide${i === index ? ' cat-slide--active' : ''}`}
          >
            {isVideo(src) ? (
              <video src={src} className="cat-media" autoPlay muted loop playsInline />
            ) : (
              <img src={src} className="cat-media" alt="" />
            )}
          </div>
        );
      })}
    </div>
  );
}
